import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import exploremembers from "./images/exploremembers.webp";
import udxplanner from "./images/udxplanner.webp";
import memebrcollabratin from "./images/memebrcollabratin.webp";
import exploreproducts from "./images/exploreproducts.webp";
import toodhucatalog from "./images/toodhucatalog.webp";

const Dashboard = () => {
  const displayTabs = [
    "Explore Members",
    "Season Planner",
    "Member Collaboration",
    "Explore Products",
    "My Catalog",
  ];

  const actualTabs = [
    "Discover and connect with business members",
    "Plan and manage operations based on seasonal trends",
    "Improve productivity through collaboration",
    "Browse and access a variety of products",
    "Create and organize digital product catalogs",
  ];

  const [activeTab, setActiveTab] = useState(actualTabs[0]);

  const tabContent = {
    "Discover and connect with business members": { text: "Business networking solutions enable discovering and connecting with members to build strong professional relationships. Ideal for small businesses, this feature enhances collaboration, expands partnerships, and supports long-term growth through seamless communication.", image: exploremembers },
    "Browse and access a variety of products": { text: "Simplify sourcing, comparison, and procurement for your business needs.", image: udxplanner },
    "Plan and manage operations based on seasonal trends": { text: "Optimize resource allocation and execution for better efficiency.", image: memebrcollabratin },
    "Improve productivity through collaboration": { text: "Enable real-time communication against transactions and seamless workflow integration.", image: exploreproducts },
    "Create and organize digital product catalogs": { text: "Ensure easy access and structured presentation for better product management.", image: toodhucatalog },
  };

  return (
    <div className="container mt-4 taping">
      {/* Tab Navigation */}
      <ul className="nav nav-tabs justify-content-center mb-3 border-bottom">
        {displayTabs.map((tab, index) => (
          <li className="nav-item d-flex align-items-center" key={tab}>
            <button
              className="nav-link border-0 inttap"
              onClick={() => setActiveTab(actualTabs[index])}
              style={{
                background: "none",
                fontSize: "16px",
                fontWeight: activeTab === actualTabs[index] ? "bold" : "normal",
                color: activeTab === actualTabs[index] ? "#000" : "#ABABAB",
              }}
            >
              {tab}
            </button>
            {index < displayTabs.length - 1 && <span className="mx-2 text-muted sidebrder">|</span>}
          </li>
        ))}
      </ul>

      {/* Tab Content */}
      <div className="tab-content p-4 text-center tpcntent">
        <img
          src={tabContent[activeTab].image}
          alt={activeTab}
          className="img-fluid mb-3"
          onError={(e) => (e.target.style.display = "none")}
        />
        <h3 className="mt-2 taptitle">{activeTab}</h3>
        <p className="tappara">{tabContent[activeTab].text}</p>
      </div>
    </div>
  );
};

export default Dashboard;